export default __webpack_public_path__ + "static/touchHover-073b82e2f5a4b348d19331ab1f4fca6a.png";